import { useEffect, useRef, useState } from "react";

import styled from "styled-components/macro";

import AddRespondentsToGroup from "Signups/SharedComponents/AddRespondentsToGroup";
import {
  MoreButton,
  MoreButtonText,
} from "Signups/SignupView/SignupSheet/Screens/Options/Options/MoreButton";

import FnrIcon from "UI/FnrIcon/FnrIcon";

export default function AddToGroup({ signupItemID }) {
  const [showPopover, setShowPopover] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);

  useEffect(() => {
    let successMsgTimeout;

    if (successMessage) {
      successMsgTimeout = setTimeout(() => {
        setSuccessMessage(null);
      }, 3000);
    }

    return () => clearTimeout(successMsgTimeout);
  }, [successMessage]);

  const buttonRef = useRef();

  const onClick = () => {
    setShowPopover((currentVal) => !currentVal);
  };

  return (
    <Wrapper>
      <MoreButton forceHover={showPopover} onClick={onClick} ref={buttonRef}>
        <FnrIcon fas fa-users />
        <MoreButtonText>Add to a group</MoreButtonText>
      </MoreButton>
      <AddRespondentsToGroup
        signupListItemID={signupItemID}
        show={showPopover}
        setShow={setShowPopover}
        buttonRef={buttonRef}
      />
    </Wrapper>
  );
}
const Wrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;
